<template>
    <div class="pdf-scroll">
        <div class="pdf-frame" ref="scrollContainer">
            <vue-pdf-embed v-if="pdfSource && pdfWidth" :source="pdfSource" :width="pdfWidth" @loaded="tryViewContract"></vue-pdf-embed>
        </div>
    </div>
</template>

<script>
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { WebApi } from '@/services/WebApi'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: 'PdfViewer',
  data () {
    return {
      error: '',
      loading: false,
      pdfSource: '',
      pdfWidth: 0
    }
  },
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: {
    contractId () {
      return this.contract.id
    }
  },
  methods: {
    tryFetchPdf () {
      const self = this
      self.error = ''
      self.loading = true
      WebApi.get('ClientContract/' + self.contractId + '/Pdf')
        .then(response => { self.pdfSource = 'data:application/pdf;base64,' + response.data })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    tryViewContract () {
      const self = this
      self.error = ''
      self.loading = true
      WebApi.put('ClientContract/' + self.contractId + '/View')
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    updatePdfWidth () {
      if (this.$refs.scrollContainer) {
        this.pdfWidth = Math.min(this.$refs.scrollContainer.clientWidth, 1100)
      }
    }
  },
  components: {
    VuePdfEmbed
  },
  created () {
    this.tryFetchPdf()
  },
  mounted () {
    this.updatePdfWidth()
    window.addEventListener('resize', this.updatePdfWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updatePdfWidth)
  }
}
</script>

<style scoped>
  .pdf-scroll {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    min-height: 0;
    width: 100%;
    background: #e9ecef;
    padding: 3rem 1rem 6rem;
  }

  .pdf-frame {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .pdf-frame :deep(.vue-pdf-embed__page) {
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  }

  .pdf-frame :deep(.vue-pdf-embed__page:last-child) {
    margin-bottom: 0;
  }
</style>
